module.exports = __webpack_public_path__ + "static/media/4.8dd585e0.jpg";